import * as types from './constants';
import * as newLoginConstants from '../NewLogin/constants';

export const authenticate = user => ({
  type: types.LOGIN_REQUEST,
  user,
});

export const logout = () => ({
  type: types.LOGOUT_REQUEST,
});

export const logoutV2 = () => ({
  type: newLoginConstants.LOGOUT_V2_REQUEST,
});

export const loginSuccess = res => ({
  type: types.LOGIN_SUCCESS,
  res,
});

export const loginFailure = error => ({
  type: types.LOGIN_FAILURE,
  error,
});

export const clearTopbarMenuData = () => ({
  type: types.CLEAR_TOPBAR_MENU_DATA,
});

export const changeOrg = (orgID, successCallback) => ({
  type: types.SWITCH_ORG_REQUEST,
  orgID,
  successCallback,
});

export const getLastSyncTime = () => ({
  type: types.LAST_SYNC_TIME_REQUEST,
});

export const getUserData = () => ({
  type: types.GET_USER_DATA_REQUEST,
});

export const getBeamerPostsExplore = callback => ({
  type: types.GET_BEAMER_POSTS_EXPLORE_REQUEST,
  callback,
});

export const getBeamerPostsNotification = () => ({
  type: types.GET_BEAMER_POSTS_NOTIFICATION_REQUEST,
});
